export const faqOG = [
    {
        question: ' What measures are in place to ensure the safety and compliance with industry standards and regulations?',
        answer: 'Our services strictly adhere to industry regulations and safety protocols, with comprehensive quality checks and regular audits in place, ensuring compliance and mitigating operational risks within the infrastructure.'
    },
    {
        question: 'How is the integration of services with existing oil and gas infrastructure ensured?',
        answer: 'We conduct meticulous planning and precision execution and deploy best practices and innovative methodologies to guarantee a smooth and efficient implementation process, ensuring minimal disruptions and downtime.'
    },
    {
        question: 'What quality control measures are in place to ensure the accuracy and precision of the solutions provided?',
        answer: 'We run rigorous quality checks at every stage, ensuring meticulous infrastructure alignment, compliance with industry standards, and precise power distribution optimization for enhanced operational efficiency.'
    },{
        question: 'How does SixD ensure on-time delivery of services?',
        answer: 'SixD’s streamlined approach integrates meticulous planning and efficient project management, along with a dedicated focus on precision and quality, ensuring that all deliverables are met within the stipulated timelines, thus guaranteeing on-time service delivery.'
    }
]

export const faqSteel = [
    {
        question: 'What kind of re-engineering solutions does SixD offer for the steel industry?',
        answer: 'SixD provides comprehensive re-engineering services that enable the replication of vital components, ensuring prolonged machinery lifespan and sustained productivity.'
    },
    {
        question: 'How does SixD ensure accuracy and efficiency in their as-built services?',
        answer: "With a meticulous approach, SixD's as-built services guarantee seamless assembly, rectify potential errors and enhance construction efficiency to deliver top-tier quality and minimize operational setbacks."
    },
    {
        question: 'How does the Dimension Control Survey benefit complex structural projects in the steel industry?',
        answer: 'Dimension Control Survey ensures precise assembly, minimizes discrepancies, and enhances operational efficacy, ensuring strict compliance with industry standards for a seamless project execution.'
    },
    {
        question: 'What advantages does a digital twin offer, and how does SixD implement it?',
        answer: 'Digital twin solutions enable real-time monitoring, predictive analysis, and informed decision-making, empowering streamlined operations and optimized performance within the steel industry.'
    },
    {
        question: 'How does SixD ensure on-time delivery of services?',
        answer: 'SixD’s streamlined approach integrates meticulous planning and efficient project management, along with a dedicated focus on precision and quality, ensuring that all deliverables are met within the stipulated timelines, thus guaranteeing on-time service delivery.'
    }
]

export const faqPower = [
    {
        question: 'What is the expected timeline for the delivery of as-built documentation for a power infrastructure project?',
        answer: 'The timeline for delivering comprehensive as-built documentation typically depends on the scope and scale of the project, with a focus on maintaining accuracy and meeting quality standards.'
    },
    {
        question: 'What are the tangible benefits we can expect from implementing digital twin technology?',
        answer: 'Digital twin implementation optimizes energy utilization, reduces downtime through predictive maintenance, and ensures uninterrupted power supply, leading to improved operational reliability and efficiency within your power infrastructure.'
    },
    {
        question: 'What quality control measures are in place to ensure the accuracy and precision of the solutions provided?',
        answer: 'We run rigorous quality checks at every stage, ensuring meticulous infrastructure alignment, compliance with industry standards, and precise power distribution optimization for enhanced operational efficiency.'
    },
    {
        question: 'How does SixD ensure on-time delivery of services?',
        answer: 'SixD’s streamlined approach integrates meticulous planning and efficient project management, along with a dedicated focus on precision and quality, ensuring that all deliverables are met within the stipulated timelines, thus guaranteeing on-time service delivery.'
    }
]

export const faqGreenEnergy = [
    {
        question: ' What measures are in place to ensure the safety and compliance with industry standards and regulations?',
        answer: 'Our services strictly adhere to industry regulations and safety protocols, with comprehensive quality checks and regular audits in place, ensuring compliance and mitigating operational risks within the infrastructure.'
    },
    {
        question: 'How is the integration of services with existing oil and gas infrastructure ensured?',
        answer: 'We conduct meticulous planning and precision execution and deploy best practices and innovative methodologies to guarantee a smooth and efficient implementation process, ensuring minimal disruptions and downtime.'
    },
    {
        question: 'What quality control measures are in place to ensure the accuracy and precision of the solutions provided?',
        answer: 'We run rigorous quality checks at every stage, ensuring meticulous infrastructure alignment, compliance with industry standards, and precise power distribution optimization for enhanced operational efficiency.'
    },
    {
        question: 'How does SixD ensure on-time delivery of services?',
        answer: 'SixD’s streamlined approach integrates meticulous planning and efficient project management, along with a dedicated focus on precision and quality, ensuring that all deliverables are met within the stipulated timelines, thus guaranteeing on-time service delivery.'
    }
]